import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-wartung-users',
    templateUrl: './wartung-users.component.html',
    styleUrls: ['./wartung-users.component.scss'],
    standalone: false
})
export class WartungUsersComponent implements OnInit {
  constructor() {
  }

  ngOnInit() {
  }
}
